import { createContext, useMemo } from "react";
import { useScheduleData } from "@RequestFormV2/sections/Schedule/context/useScheduleData";

type ScheduleContextType = ReturnType<typeof useScheduleData>;

const ScheduleContext = createContext<ScheduleContextType | null>(null);

function ScheduleProvider({ children }: { children: React.ReactNode }) {
  const data = useScheduleData();

  const value = useMemo(() => data, [data]);

  return <ScheduleContext.Provider value={value}>{children}</ScheduleContext.Provider>;
}

export { ScheduleContext, ScheduleProvider };
